import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransferDispatchBoxResponse } from '../../models/transfer-dispatchbox.model';

@Component({
  selector: 'app-switch-box',
  standalone: false,
  templateUrl: './switch-box.component.html',
  styleUrl: './switch-box.component.css',
})
export class SwitchBoxComponent {
  @Input() header: string = '';
  @Input() dispatchBoxes: TransferDispatchBoxResponse[] = [];
  @Input() selectedDispatchBoxes: TransferDispatchBoxResponse = new TransferDispatchBoxResponse();
  @Output() selectedChange = new EventEmitter<TransferDispatchBoxResponse>();

  onSelectBox(box: TransferDispatchBoxResponse) {
    this.selectedDispatchBoxes = box;
    this.selectedChange.emit(box); // send to parent
  }
}
